<template>
  <el-container class="layout" v-if="displayLayout">
    <el-aside>
      <slot name="nav"></slot>
    </el-aside>
    <el-main class="layout__main"
      :class="{'hide-action-bar': hideActionBar}">
      <div class="layout__main__header--mobile">
          <nav-header></nav-header>
      </div>
      <div class="layout__main__body" id="layout_main_body" :class="{'no-scroll': noScroll}">
        <slot></slot>
      </div>
      <layout-action-bar v-show="!hideActionBar"/>
    </el-main>
    <el-aside v-if="displayAdviceSide">
      <slot name="advice"></slot>
    </el-aside>
  </el-container>
  <router-view v-else></router-view>
</template>

<script>

import { mapGetters } from 'vuex';
import LayoutActionBar from './LayoutNavigationBar.vue';
import NavHeader from '@/components/navbar/NavHeader.vue';

export default {
  name: 'NLayout',
  components: { LayoutActionBar, NavHeader },
  computed: {
    ...mapGetters({
      stepStore: 'projectStore/step',
      isMobile: 'dimensionStore/isMobile',
      childRoute: 'routeStore/childRoute',
    }),
    displayLayout() {
      return this.$route.meta.layout !== 'NONE';
    },
    displayAdviceSide() {
      return this.$route.meta.layout !== 'SIDE_ONLY';
    },
    hideActionBar() {
      return this.$route.meta.hideActionBar;
    },
    noScroll() {
      return this.childRoute === 'inventory';
    },
  },

};
</script>

<style lang="scss">
  .el-aside{
    overflow: hidden;
    display: none;
    @include breakpoint(desktop){
      display: unset;
    }
  }
  .el-main{
    overflow: hidden;
    padding: 0;
    @include breakpoint(desktop) {
      padding: unset;
    }
  }
  .layout {
    height: 100%;
    &__main{
      display: flex;
      flex-direction: column;

      &__header {
        padding: .4em 0;
        &--mobile{
          @include breakpoint(desktop){
            display: none;
          }
        }
      }
      &__body{
        flex: 1;
        overflow-y: scroll;
        overflow-x: hidden;
        scroll-behavior: smooth;
        padding: 0 10px;
        @include breakpoint(desktop) {
          overflow-y: auto;
          overflow-x: hidden;
          padding: 0 20px;
        }
      }
     .action-bar {
       height: 60px;
       @include breakpoint(desktop) {
         height: 75px;
       }
     }
    }
  }
  .no-scroll{
    overflow: hidden;
  }
</style>
